import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#D80027\" d=\"M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12L12 0c6.627 0 12 5.373 12 12\"></path><path fill=\"#0052B4\" d=\"M12 12V0C5.373 0 0 5.373 0 12z\"></path><path fill=\"#F0F0F0\" d=\"m10.435 7.023-1.466.69.78 1.419-1.59-.305-.202 1.608-1.109-1.183-1.108 1.183-.202-1.608-1.591.305.78-1.42-1.465-.69 1.465-.688-.78-1.42 1.591.305.202-1.608 1.108 1.182 1.109-1.182.201 1.608 1.592-.305-.78 1.42z\"></path><path fill=\"#0052B4\" d=\"M6.847 9.257a2.234 2.234 0 1 0 0-4.468 2.234 2.234 0 0 0 0 4.468\"></path><path fill=\"#F0F0F0\" d=\"M6.846 8.214c-.656 0-1.19-.534-1.19-1.19 0-.657.534-1.19 1.19-1.19.657 0 1.19.533 1.19 1.19s-.533 1.19-1.19 1.19\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_7]))
}
export default { render: render }